<template>
<v-container fluid grid-list-lg>
  <v-layout row wrap>
    <v-flex>
      <v-card>
        <v-card-title primary-title class="primary white--text headline">
          User Form
        </v-card-title>
        <v-card-text>
          <form>
            <v-layout row>
              <v-flex xs6>
                <v-text-field
                disabled
                v-model="item.id"
                label="ID">
                </v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                disabled
                v-model="item.createdDate"
                label="Created Date"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs6>
                <v-text-field
                v-validate="'required|min:3'"
                data-vv-name="first name"
                :error-messages="errors.collect('first name')"
                v-model="item.firstName"
                label="First Name">
                </v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                v-validate="'required|min:2'"
                data-vv-name="last name"
                :error-messages="errors.collect('last name')"
                v-model="item.lastName"
                label="Last Name">
                </v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs4>
                <v-text-field
                v-validate="'required|min:3|alpha_dash'"
                data-vv-name="username"
                :error-messages="errors.collect('username')"
                v-model="item.username"
                label="Username">
                </v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field
                v-validate="'required|email'"
                data-vv-name="email"
                :error-messages="errors.collect('email')"
                v-model="item.email"
                label="E-Mail">
                </v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field
                v-validate="'required|numeric'"
                data-vv-name="phone number"
                :error-messages="errors.collect('phone number')"
                v-model="item.phoneNumber"
                mask="phone"
                label="Phone Number">
                </v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row v-if="isNew">
              <v-flex xs6>
                <v-text-field
                ref="password"
                data-vv-delay="300"
                v-validate="'required|min:6'"
                data-vv-name="password"
                :error-messages="errors.collect('password')"
                v-model="item.password"
                type="password"
                label="Password">
                </v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                v-validate="'required|confirmed:password'"
                data-vv-delay="300"
                data-vv-name="password confirmation"
                :error-messages="errors.collect('password confirmation')"
                type="password"
                v-model="item.passwordConfirm"
                target="password"
                label="Confirm Passowrd">
                </v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <v-select
                v-validate="'required'"
                data-vv-name="role"
                :error-messages="errors.collect('role')"
                dense
                label="Roles"
                small-chips
                deletable-chips
                :items="roleCollection"
                item-text="Name"
                item-value="id"
                v-model="item.roles"
                multiple>
                </v-select>
              </v-flex>
            </v-layout>
          </form>
        </v-card-text>
        <v-card-actions style="background: hsl(0, 0%, 97%)" class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat depressed @click.native="cancel" :disabled="saveLoading">Cancel</v-btn>
          <v-btn color="accent" class="white--text" depressed @click.native="validateBeforeSubmit(save)" :loading="saveLoading" :disabled="saveLoading">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Vue from 'vue'

export default {
  name: 'user-item',
  props: {
    id: {
      type: String,
      required: false,
      default: ''
    }
  },
  created () {
    if (!this.isNew) {
      this.setLoader({
        loading: true
      })
      this.fetchUser()
    }
  },
  data () {
    return {
      item: {
        id: '',
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        username: '',
        roles: [],
        isActive: true,
        password: '',
        passwordConfirm: ''
      },
      saveLoading: false
    }
  },
  computed: {
    isNew () {
      return this.id == null || this.id === ''
    },
    ...mapState({
      roleCollection: state => state.configurations.rawRoles
    })
  },
  methods: {
    cancel () {
      this.$router.go(-1)
    },
    fetchUser () {
      this.axios.get(`/users/${this.id}`)
        .then(response => {
          this.setUserItem(response.data)
        })
        .catch(error => {
          this.handleAxiosError(error)
        })
        .finally(() => {
          this.setLoader({
            loading: false
          })
        })
    },
    setUserItem (item) {
      item = this.mapUserItem(item)
      this.item = item
      this.item.id = this.id
      this.item.createdDate = item.createdDate
      this.item.password = ''
      this.item.passwordConfirm = ''
    },
    mapUserItem (user) {
      return {
        firstName: user.FirstName,
        lastName: user.LastName,
        email: user.Email,
        phoneNumber: user.PhoneNumber,
        username: user.Username,
        roles: user.Roles,
        isActive: user.IsActive,
        createdDate: Vue.options.filters.formatDate(user.CreatedDate)
      }
    },
    save () {
      this.saveLoading = true
      let itemToSave = {
        first_name: this.item.firstName,
        last_name: this.item.lastName,
        is_active: this.item.isActive,
        email: this.item.email,
        phone_number: this.item.phoneNumber,
        username: this.item.username,
        roles: this.item.roles,
        created_date: this.item.createdDate
      }

      if (this.isNew) {
        itemToSave.is_active = true
        itemToSave.password = this.item.password
        this.axios.post('/users', itemToSave)
          .then(response => {
            this.setSnack({
              message: 'Successful',
              type: 'success'
            })
            this.$router.go(-1)
          })
          .catch(error => {
            this.handleAxiosError(error)
          })
          .finally(() => {
            this.saveLoading = false
          })
      } else {
        this.axios.put(`/users/${this.item.id}`, itemToSave)
          .then(response => {
            this.setSnack({
              message: 'Successful',
              type: 'success'
            })
            this.$router.go(-1)
          })
          .catch(error => {
            this.handleAxiosError(error)
          })
          .finally(() => {
            this.saveLoading = false
          })
      }
    },
    ...mapActions({
      setSnack: 'snackbar/setSnack',
      setLoader: 'loader/setLoader'
    })
  },
  watch: {
    saveLoading (val) {
      this.setLoader({
        loading: val
      })
    }
  }
}
</script>

<style>

</style>
